import { SVGProps } from "react";

export const SenecDigitalIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            version="1.1"
            id="Pikto"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100%"
            height="100%"
            viewBox="0 0 48 48"
            xmlSpace="preserve"
            {...props}
        >
            <path
                fill="#FE8F11"
                d="M9,25c0.55273,0,1-0.44727,1-1v-8.64648C10,15.1582,10.1582,15,10.35352,15H20v3h7v-7h-7v2h-9.64648
        C9.05566,13,8,14.05566,8,15.35352V24C8,24.55273,8.44727,25,9,25z M22,13h3v3h-3V13z M26,21h2.99188v2.99188H26V21z M31,28h2v3H10
        v-2c0-0.55273-0.44727-1-1-1s-1,0.44727-1,1v4h27v-5h7V17H31V28z M33,19h7v7h-7V19z M37,7h-8v8h8V7z M35,13h-4V9h4V13z
         M42.99188,11.00812V14H40v-2.99188H42.99188z M5,38c0,1.6543,1.3457,3,3,3h27c1.6543,0,3-1.3457,3-3v-3H5V38z M7,37h29v1
        c0,0.55176-0.44824,1-1,1H8c-0.55176,0-1-0.44824-1-1V37z"
            />
        </svg>
    );
};
